require.register("modules/m02/m02-activity/page-6b/page-6b", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page6b = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page6b;

  
});

